module.exports = {"views.headerAndSidebarLayout.sidebar.navList.item1":"サブスクリプション","views.headerAndSidebarLayout.sidebar.navList.item2":"設定","views.headerAndSidebarLayout.sidebar.navList.item3":"データポリシー","views.headerAndSidebarLayout.sidebar.description":"何か手伝いましょうか？ でお問い合わせください：","views.headerAndSidebarLayout.sidebar.customerCare":"顧客サービス","views.headerAndSidebarLayout.header.signOut.text":"サインアウト","views.headerAndSidebarLayout.header.contactUs.text":"お問い合わせ"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/views/HeaderAndSidebarLayout.json
// module id = 816
// module chunks = 0